<template>
    <section>
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

        <b-field horizontal label="Название">
            <b-input name="subject" expanded v-model="title"></b-input>
        </b-field>

        <b-field horizontal label="Описание">
            <b-input type="textarea" expanded v-model="description"></b-input>
        </b-field>

        <b-field horizontal label="Активность">
            <b-checkbox expanded v-model="isActive"></b-checkbox>
        </b-field>

        <b-field horizontal label="Действие">
            <promo-action-select :action.sync="action"/>
        </b-field>

        <b-field v-if="action === 1" horizontal label="Блюдо">
            <dish-select :dish.sync="dish"/>
        </b-field>

        <b-field v-if="action === 2" horizontal label="Комбо">
            <combo-select :combo.sync="combo"/>
        </b-field>

        <b-field v-if="action === 3" horizontal label="Ссылка">
            <b-field horizontal label="В новой вкладке">
                <b-checkbox v-model="blank"></b-checkbox>
            </b-field>
            <br/>
            <b-field horizontal label="Ссылка">
                <b-input v-model="url" placeholder="Ссылка"></b-input>
            </b-field>
        </b-field>

        <div class="block">
            <b-field horizontal label="Изображение">
                <b-upload v-model="uploadImage" drag-drop>
                    <section>
                        <div class="content has-text-centered">
                            <img style="width: 930px; height: 350px" :src="uploadImage ? uploadedImage:  image">
                        </div>
                    </section>
                </b-upload>
            </b-field>
        </div>

        <b-field horizontal>
            <p class="control">
                <b-button label="Сохранить" type="is-primary" @click="edit()" :disabled="loading"/>
            </p>
        </b-field>
    </section>
</template>

<script>
import promoRepository from "../../repository/promoRepository";
import PromoActionSelect from "../../components/Common/PromoActionSelect";
import ComboSelect from "../../components/Common/ComboSelect";
import DishSelect from "../../components/Common/DishSelect";

export default {
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    components: {DishSelect, ComboSelect, PromoActionSelect},
    computed: {
        uploadedImage() {
            if (!this.uploadImage)
                return;

            return URL.createObjectURL(this.uploadImage);
        },
        infoParam() {
            switch (this.action) {
                case 1:
                    return {
                        id: this.dish
                    };
                case 2:
                    return {
                        id: this.combo
                    };
                case 3:
                    return {
                        blank: this.blank,
                        url: this.url
                    }
                default:
                    return null;
            }
        }
    },
    data() {
        return {
            title: null,
            description: null,
            isActive: true,
            action: null,
            image: null,
            combo: null,
            dish: null,
            uploadImage: null,
            blank: undefined,
            url: undefined,
            loading: false
        }
    },
    methods: {
        fetchData() {
            this.loading = true;

            promoRepository.get(this.id)
                .then(({data}) => {
                    this.title = data.title
                    this.description = data.description
                    this.isActive = data.is_active === 1
                    this.image = data.image
                    this.action = data.action

                    if (data.action === 1) {
                        this.dish = data.info.id
                    } else if (data.action === 2) {
                        this.combo = data.info.id
                    } else if(data.action === 3){
                        this.url = data.info.url
                        this.blank = data.info.blank
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        edit() {
            this.loading = true;

            promoRepository.edit(this.id, this.title, this.description, this.uploadImage, this.action, JSON.stringify(this.infoParam), this.isActive)
                .then(() => this.$router.push({name: "Promo"}))
                .then(() => this.$buefy.toast.open('Акция обновлена'))
                .catch(() => this.$buefy.toast.open('Ошибка при обновлении акции'))
                .finally(() => {
                    this.loading = false
                })
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>

<style scoped>

</style>
